export const INSURED_MAX_AGE_TRAVEL = 85;//Edad en años
export const SPANISH_COUNTRY_OPTION = 'España';
export const TRAVEL_COUNTRIES_FIELDS = {
    RESIDENCE_COUNTRY: 'residenceCountry',
    TRAVEL_DESTINATION: 'travelDestination',
}